/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Viewallrecords2Inputs */

const zh_learn_viewallrecords2 = /** @type {(inputs: Learn_Viewallrecords2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看全部记录`)
};

const en_learn_viewallrecords2 = /** @type {(inputs: Learn_Viewallrecords2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View all records`)
};

const es_learn_viewallrecords2 = /** @type {(inputs: Learn_Viewallrecords2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver todos los registros`)
};

/**
* | output |
* | --- |
* | "View all records" |
*
* @param {Learn_Viewallrecords2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_viewallrecords2 = /** @type {((inputs?: Learn_Viewallrecords2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Viewallrecords2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_viewallrecords2(inputs)
	if (locale === "en") return en_learn_viewallrecords2(inputs)
	return es_learn_viewallrecords2(inputs)
});
export { learn_viewallrecords2 as "learn_viewAllRecords" }